var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box p-3" }, [
    _vm.isAddressLoading
      ? _c(
          "div",
          { staticClass: "has-text-centered" },
          [
            _c("PulseLoader", {
              attrs: { loading: true, color: "#00d1b2", size: "12px" },
            }),
          ],
          1
        )
      : _c("div", [
          _c("div", { staticClass: "columns is-multiline mb-2" }, [
            _c("div", { staticClass: "column is-full" }, [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-justify-content-space-between is-align-items-end",
                },
                [
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label is-small mb-0" }, [
                      _vm._v("Name"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.DistributionZoneName,
                            expression: "DistributionZoneName",
                          },
                        ],
                        staticClass: "input is-small",
                        attrs: { type: "text" },
                        domProps: { value: _vm.DistributionZoneName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.DistributionZoneName = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", { staticClass: "label is-small mb-0" }, [
                      _vm._v("Type"),
                    ]),
                    _c("div", { staticClass: "control" }, [
                      _c("div", { staticClass: "select is-small" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.DistributionZoneType,
                                expression: "DistributionZoneType",
                              },
                            ],
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.DistributionZoneType = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(
                            _vm.store.getters.DistributionZoneTypes,
                            function (type) {
                              return _c(
                                "option",
                                { key: type.value, domProps: { value: type } },
                                [_vm._v(" " + _vm._s(type.label) + " ")]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "tabs is-small is-success mb-2" }, [
            _c("ul", [
              _c(
                "li",
                { class: { "is-active": _vm.activeTab === "location" } },
                [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "location"
                        },
                      },
                    },
                    [_vm._v("Location")]
                  ),
                ]
              ),
              _vm.DistributionZoneType.label !== "CENTER ZONE"
                ? _c(
                    "li",
                    { class: { "is-active": _vm.activeTab === "details" } },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "details"
                            },
                          },
                        },
                        [_vm._v("Details")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.DistributionZoneType.label !== "CENTER ZONE"
                ? _c(
                    "li",
                    { class: { "is-active": _vm.activeTab === "features" } },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "features"
                            },
                          },
                        },
                        [_vm._v("Features")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.DistributionZoneType.label !== "CENTER ZONE"
                ? _c(
                    "li",
                    {
                      class: { "is-active": _vm.activeTab === "daysOfService" },
                    },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              _vm.activeTab = "daysOfService"
                            },
                          },
                        },
                        [_vm._v("Days of Service")]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "tab-content-container" }, [
            _vm.activeTab === "location"
              ? _c("div", { staticClass: "tab-content" }, [
                  _c("div", { staticClass: "columns is-multiline is-mobile" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Region"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "select is-small is-fullwidth" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.Region.id,
                                      expression: "Region.id",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.Region,
                                        "id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.store.state.regions,
                                  function (region) {
                                    return _c(
                                      "option",
                                      {
                                        key: region.id,
                                        domProps: { value: region.id },
                                      },
                                      [_vm._v(" " + _vm._s(region.name) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Search Address"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            ref: "autocomplete",
                            staticClass: "input is-small",
                            attrs: {
                              type: "text",
                              placeholder: "Enter a location",
                            },
                            on: { focus: _vm.onInputFocus },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Coordinates (Lat/Lng)"),
                        ]),
                        _c("div", { staticClass: "field has-addons" }, [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.Latitude,
                                  expression: "Latitude",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "input is-small",
                              attrs: {
                                type: "number",
                                disabled: _vm.geocoding_loading,
                              },
                              domProps: { value: _vm.Latitude },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.Latitude = _vm._n($event.target.value)
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: _vm.Longitude,
                                  expression: "Longitude",
                                  modifiers: { number: true },
                                },
                              ],
                              staticClass: "input is-small",
                              attrs: {
                                type: "number",
                                disabled: _vm.geocoding_loading,
                              },
                              domProps: { value: _vm.Longitude },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.Longitude = _vm._n($event.target.value)
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-small is-borderless",
                                class: {
                                  "is-loading":
                                    _vm.geocoding_loading || _vm.loading,
                                },
                                on: { click: _vm.getCoordinates },
                              },
                              [_vm._v(" Get ")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "columns is-mobile" }, [
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Country")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "div",
                                { staticClass: "select is-small is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.Country,
                                          expression: "Country",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.Country = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.store.getters.Countries,
                                      function (country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country.value,
                                            domProps: { value: country },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(country.label) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Province")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "div",
                                { staticClass: "select is-small is-fullwidth" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.Province,
                                          expression: "Province",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.Province = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.store.getters.TaxProvinces,
                                      function (province) {
                                        return _c(
                                          "option",
                                          {
                                            key: province.Province,
                                            domProps: {
                                              value: province.Province,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(province.Province) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "columns is-mobile" }, [
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("City")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.City,
                                    expression: "City",
                                  },
                                ],
                                staticClass: "input is-small",
                                attrs: { type: "text" },
                                domProps: { value: _vm.City },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.City = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Postal Code")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.PostalCode,
                                    expression: "PostalCode",
                                  },
                                ],
                                staticClass: "input is-small",
                                attrs: { type: "text" },
                                domProps: { value: _vm.PostalCode },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.PostalCode = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "columns is-mobile" }, [
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Door Number")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.DoorNumber,
                                    expression: "DoorNumber",
                                  },
                                ],
                                staticClass: "input is-small",
                                attrs: { type: "text" },
                                domProps: { value: _vm.DoorNumber },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.DoorNumber = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Apartment")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.Apartment,
                                    expression: "Apartment",
                                  },
                                ],
                                staticClass: "input is-small",
                                attrs: { type: "text" },
                                domProps: { value: _vm.Apartment },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.Apartment = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Street"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.Street,
                                expression: "Street",
                              },
                            ],
                            staticClass: "input is-small",
                            attrs: { type: "text" },
                            domProps: { value: _vm.Street },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.Street = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.activeTab === "details"
              ? _c("div", { staticClass: "tab-content" }, [
                  _c("div", { staticClass: "columns is-multiline is-mobile" }, [
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Facility"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c(
                            "div",
                            { staticClass: "select is-fullwidth is-small" },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.Facility,
                                      expression: "Facility",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.Facility = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.store.getters.Facility,
                                  function (type) {
                                    return _c(
                                      "option",
                                      { key: type, domProps: { value: type } },
                                      [_vm._v(" " + _vm._s(type) + " ")]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm.DistributionZoneType.label === "STORE"
                      ? _c("div", { staticClass: "column is-half" }, [
                          _c("div", { staticClass: "field" }, [
                            _c(
                              "label",
                              { staticClass: "label is-small mb-0" },
                              [_vm._v("Client")]
                            ),
                            _c("div", { staticClass: "control" }, [
                              _c(
                                "div",
                                { staticClass: "select is-fullwidth is-small" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.Vendor,
                                          expression: "Vendor",
                                        },
                                      ],
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.Vendor = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(
                                      _vm.store.state.vendors,
                                      function (vendor) {
                                        return _c(
                                          "option",
                                          {
                                            key: vendor.Id,
                                            domProps: { value: vendor.Id },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(vendor.businessUnit) +
                                                "***" +
                                                _vm._s(vendor.subBusinessUnit) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Phone"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.PhoneNumber,
                                expression: "PhoneNumber",
                              },
                            ],
                            staticClass: "input is-small",
                            attrs: { type: "tel", placeholder: "xxxxxxxxxx" },
                            domProps: { value: _vm.PhoneNumber },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.PhoneNumber = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Size (Sq. Ft.)"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.Size,
                                expression: "Size",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "input is-small",
                            attrs: { type: "number" },
                            domProps: { value: _vm.Size },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.Size = _vm._n($event.target.value)
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "column is-half" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "label is-small mb-0" }, [
                          _vm._v("Number Of Employees"),
                        ]),
                        _c("div", { staticClass: "control" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.number",
                                value: _vm.NumberOfEmployees,
                                expression: "NumberOfEmployees",
                                modifiers: { number: true },
                              },
                            ],
                            staticClass: "input is-small",
                            attrs: { type: "number" },
                            domProps: { value: _vm.NumberOfEmployees },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.NumberOfEmployees = _vm._n(
                                  $event.target.value
                                )
                              },
                              blur: function ($event) {
                                return _vm.$forceUpdate()
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.activeTab === "features"
              ? _c("div", { staticClass: "tab-content" }, [
                  _c("div", { staticClass: "field mb-3" }, [
                    _c("label", { staticClass: "label is-small mb-2" }, [
                      _vm._v("Distribution Zone Features"),
                    ]),
                    _c("div", { staticClass: "tags" }, [
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-primary": _vm.IsFinalMile,
                            "is-light": !_vm.IsFinalMile,
                          },
                          on: {
                            click: function ($event) {
                              _vm.IsFinalMile = !_vm.IsFinalMile
                            },
                          },
                        },
                        [_vm._v(" Final Mile ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-primary": _vm.IsForReverse,
                            "is-light": !_vm.IsForReverse,
                          },
                          on: {
                            click: function ($event) {
                              _vm.IsForReverse = !_vm.IsForReverse
                            },
                          },
                        },
                        [_vm._v(" Reverse Logistics ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-primary": _vm.AllowCrossdock,
                            "is-light": !_vm.AllowCrossdock,
                          },
                          on: {
                            click: function ($event) {
                              _vm.AllowCrossdock = !_vm.AllowCrossdock
                            },
                          },
                        },
                        [_vm._v(" Crossdock ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-primary": _vm.AllowOvernightReception,
                            "is-light": !_vm.AllowOvernightReception,
                          },
                          on: {
                            click: function ($event) {
                              _vm.AllowOvernightReception =
                                !_vm.AllowOvernightReception
                            },
                          },
                        },
                        [_vm._v(" Overnight Reception ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-primary":
                              _vm.CustomFields.shouldConsiderFuelSurcharge,
                            "is-light":
                              !_vm.CustomFields.shouldConsiderFuelSurcharge,
                          },
                          on: {
                            click: function ($event) {
                              _vm.CustomFields.shouldConsiderFuelSurcharge =
                                !_vm.CustomFields.shouldConsiderFuelSurcharge
                            },
                          },
                        },
                        [_vm._v(" Fuel Surcharge ")]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "field mb-3" }, [
                    _c("label", { staticClass: "label is-small mb-2" }, [
                      _vm._v("Data Source"),
                    ]),
                    _c("div", { staticClass: "tags" }, [
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-success": _vm.CustomFields.IsCDSRegion,
                            "is-light": !_vm.CustomFields.IsCDSRegion,
                          },
                          on: {
                            click: function ($event) {
                              _vm.CustomFields.IsCDSRegion =
                                !_vm.CustomFields.IsCDSRegion
                            },
                          },
                        },
                        [_vm._v(" Shyftbase ")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "tag is-small",
                          class: {
                            "is-success": _vm.CustomFields.IsCustomerRegion,
                            "is-light": !_vm.CustomFields.IsCustomerRegion,
                          },
                          on: {
                            click: function ($event) {
                              _vm.CustomFields.IsCustomerRegion =
                                !_vm.CustomFields.IsCustomerRegion
                            },
                          },
                        },
                        [_vm._v(" External ")]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.activeTab === "daysOfService"
              ? _c("div", { staticClass: "tab-content" }, [
                  _c("div", { staticClass: "field mb-3" }, [
                    _c("label", { staticClass: "label is-small mb-2" }, [
                      _vm._v("Select Days of Service"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "tags" },
                      _vm._l(_vm.daysOfWeek, function (day) {
                        return _c(
                          "span",
                          {
                            key: day.value,
                            staticClass: "tag is-small",
                            class: {
                              "is-primary": _vm.daysOfService[day.value],
                              "is-light": !_vm.daysOfService[day.value],
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleDay(day.value)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(day.label) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                {
                  staticClass: "notification m-0 p-2",
                  staticStyle: { "background-color": "white" },
                },
                [
                  _c("div", { staticClass: "is-size-7 has-text-danger" }, [
                    _vm._v(" " + _vm._s(_vm.msg || _vm.err_message) + " "),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "column is-half" }, [
              _c(
                "div",
                { staticClass: "field is-grouped is-grouped-right m-0" },
                [
                  _c("p", { staticClass: "control m-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-danger",
                        class: {
                          "is-loading": _vm.isSaving || _vm.geocoding_loading,
                        },
                        staticStyle: { "border-radius": "5px" },
                        attrs: { disabled: _vm.isSaving },
                        on: { click: _vm.removeHub },
                      },
                      [_vm._v(" Remove ")]
                    ),
                  ]),
                  _c("p", { staticClass: "control m-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-primary",
                        class: {
                          "is-loading": _vm.isSaving || _vm.geocoding_loading,
                        },
                        staticStyle: { "border-radius": "5px" },
                        attrs: { disabled: _vm.isSaving },
                        on: { click: _vm.saveToFirestore },
                      },
                      [_vm._v(" Save ")]
                    ),
                  ]),
                  _c("p", { staticClass: "control m-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small is-light",
                        staticStyle: { "border-radius": "5px" },
                        attrs: { disabled: _vm.isSaving },
                        on: { click: _vm.reset },
                      },
                      [_vm._v(" Reset ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }